<template>
  <!--srcviewscompanydetailsBackgroundSnapshotvuehtmlStart-->

  <div id="defaultId1" class="detail_con import_detail_root">
    <gui_card id="ge6845" class="uc1096" label="" :isShowLabel="false">
      <div>
        <svg
          t="1728612191932"
          @click="$router.go(-1)"
          ref="scrollContainers"
          class="icon import_detail_root_back"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="9222"
          width="24"
          height="24"
        >
          <path
            d="M879.476364 470.341818H244.829091L507.112727 209.454545a41.658182 41.658182 0 0 0-58.88-58.88L114.967273 482.676364a41.890909 41.890909 0 0 0 0 58.88l333.265454 333.032727a41.658182 41.658182 0 0 0 58.88 0 41.890909 41.890909 0 0 0 0-58.88L244.829091 553.658182h634.647273a41.658182 41.658182 0 1 0 0-83.316364z"
            p-id="9223"
            fill="#1296db"
          ></path>
        </svg>
        <!-- <svg t="1718768811694" @click="$router.go(-1)" class="icon" viewBox="0 0 1024 1024" version="1.1"
          xmlns="http://www.w3.org/2000/svg" p-id="4349" width="40" height="40">
          <path
            d="M938.666667 533.333333a21.333333 21.333333 0 0 1-21.333334 21.333334H158.166667l134.253333 134.246666a21.333333 21.333333 0 1 1-30.173333 30.173334l-170.666667-170.666667a21.333333 21.333333 0 0 1 0-30.173333l170.666667-170.666667a21.333333 21.333333 0 0 1 30.173333 30.173333L158.166667 512H917.333333a21.333333 21.333333 0 0 1 21.333334 21.333333z"
            fill="#1290C9" p-id="4350"></path>
        </svg> -->
        <div
          class="importDetail-head flex_center_between_box"
          style="align-items: center"
        >
          <div class="importDetail-item">
            <span class="importDetail-item-txt"
              >{{ $t("ShippingOrderDetails.Date") }}:</span
            >
            <span class="importDetail-item-conter">
              <span class="font_bold">{{ value?.imp_year }}</span>
              <span class="font_bold" v-if="value?.imp_month">-</span>
              <span class="font_bold">{{ value?.imp_month }}</span>
              <span class="font_bold" v-if="value?.imp_day">-</span>
              <span class="font_bold">{{
                value?.imp_day ? value?.imp_day : ""
              }}</span>
            </span>
          </div>
          <div class="importDetail-item">
            <span class="importDetail-item-txt"
              >{{ $t("ShippingOrderDetails.MasterBillofLading") }}:</span
            >
            <span class="importDetail-item-conter">{{
              value?.master_bill_of_lading
            }}</span>
          </div>
          <div class="importDetail-item">
            <span class="importDetail-item-txt"
              >{{ $t("ShippingOrderDetails.Source") }}:</span
            >
            <span class="importDetail-item-conter">
              <span class="font_bold">{{ value?.channel_no }}_</span>
              <span class="font_bold" v-if="value?.iesign == 'i'">IMPORT</span>
              <span class="font_bold" v-if="value?.iesign == 'e'">EXPORT</span>
            </span>
          </div>
          <div class="importDetail-item">
            <span class="importDetail-item-txt"
              >{{ $t("ShippingOrderDetails.BillNo") }}:</span
            >
            <span class="importDetail-item-conter">
              <span class="font_bold">{{ value?.source_id }}</span>
              <span v-if="value?.source_id_type" class="font_bold"
                >({{ value?.source_id_type }})</span
              ></span
            >
          </div>
        </div>
        <h2 class="operations-head">
          {{ $t("ShippingOrderDetails.ImportExport") }}
        </h2>
        <div class="">
          <div class="importDetail-content-item flex_center_between_box">
            <div class="importDetail-content-head">
              {{ $t("ShippingOrderDetails.ImporterBuyer") }}
            </div>
            <div class="importDetail-content-head">
              {{ $t("ShippingOrderDetails.ExporterSeller") }}
            </div>
          </div>
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-import">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Name") }}
              </div>
              <div
                class="importtext"
                @click="
                  tradetodetail(value?.importer_aaaid, value?.importer_country)
                "
              >
                {{ value?.importer_name }}
              </div>
            </div>
            <div class="importDetail-content-import">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Name") }}
              </div>
              <div class="importtext">{{ value?.supplier_name }}</div>
            </div>
            <!-- <div class="importDetail-content-import">Exporter / Seller</div> -->
          </div>
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-import">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Address") }}
              </div>
              <div class="importtexttwo">{{ value?.importer_address }}</div>
            </div>
            <div class="importDetail-content-import">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Address") }}
              </div>
              <div class="importtexttwo">{{ value?.supplier_address }}</div>
            </div>
            <!-- <div class="importDetail-content-import">Exporter / Seller</div> -->
          </div>
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-import">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Country") }}
              </div>
              <div class="importtext">
                {{ getCountry(value?.importer_country) }}
              </div>
            </div>
            <div class="importDetail-content-import">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Country") }}
              </div>
              <div class="importtext">
                {{ getCountry(value?.supplier_country) }}
              </div>
            </div>
            <!-- <div class="importDetail-content-import">Exporter / Seller</div> -->
          </div>
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-import">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Contact") }}
              </div>
              <div class="importtexttwo">{{ value?.importer_contact }}</div>
            </div>
            <div class="importDetail-content-import">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Contact") }}
              </div>
              <div class="importtexttwo">{{ value?.supplier_contact }}</div>
            </div>
            <!-- <div class="importDetail-content-import">Exporter / Seller</div> -->
          </div>
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-import">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Email") }}
              </div>
              <div class="importtexttwo">{{ value?.importer_email }}</div>
            </div>
            <div class="importDetail-content-import">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Email") }}
              </div>
              <div class="importtexttwo">{{ value?.supplier_email }}</div>
            </div>
            <!-- <div class="importDetail-content-import">Exporter / Seller</div> -->
          </div>
        </div>
      </div>
    </gui_card>
    <gui_card id="ge6845" class="uc1096" label="" :isShowLabel="false">
      <div>
        <h2 class="operations-head">
          {{ $t("ShippingOrderDetails.CargoInfo") }}
        </h2>
        <div class="importDetail-content">
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.HSCode") }}
              </div>
              <div class="importtexttwo">{{ value?.hs_code }}</div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Quantity") }}
              </div>
              <div class="importtexttwo">{{ value?.quantity }}</div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.WeightUnit") }}
              </div>
              <div class="importtexttwo">{{ value?.weight_unit }}</div>
            </div>
            <!-- <div class="importDetail-content-import">Exporter / Seller</div> -->
          </div>
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.ProductDescription") }}
              </div>
              <div class="importtexttwo">
                <div
                  v-if="!isExpanded"
                  @click="toggleExpanded"
                  v-html="limitedDescription"
                ></div>
                <div
                  v-else
                  @click="toggleExpanded"
                  v-html="value?.commodity_description"
                ></div>
                <span
                  style="
                    float: right;
                    color: #1290c9;
                    cursor: pointer;
                    text-decoration: underline;
                  "
                  v-if="value?.commodity_description?.length > maxCharacters"
                  @click="toggleExpanded"
                  >{{ isExpanded ? "Retract" : "Expand All Content" }}</span
                >
              </div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Amount") }}
              </div>
              <div class="importtexttwo" v-if="value?.fob_usd != null">
                {{ value?.fob_usd }}
              </div>
              <div class="importtexttwo" v-else>
                {{ value?.other_currency }}{{ value?.fob_oc }}
              </div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.QuantityUnit") }}
              </div>
              <div class="importtexttwo">{{ value?.quantity_unit }}</div>
            </div>
          </div>
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Weight") }}
              </div>
              <div class="importtexttwo">{{ value?.weight }}</div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.HSDescription") }}
              </div>
              <div class="importtexttwo">{{ value?.hs_code_description }}</div>

              <!-- <div class="importDetail-content-import">Exporter / Seller</div> -->
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Incoterms") }}
              </div>
              <div
                class="importtexttwo"
                v-if="value?.value_type == 'CIF' || value?.value_type == 'FOB'"
              >
                {{ value?.value_type }}
              </div>
              <div class="importtexttwo" v-else></div>
            </div>
          </div>
        </div>
      </div>
    </gui_card>
    <gui_card id="ge6845" class="uc1096" label="" :isShowLabel="false">
      <div>
        <h2 class="operations-head">
          {{ $t("ShippingOrderDetails.ShippingInfo") }}
        </h2>
        <div class="importDetail-content">
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Vessel") }}
              </div>
              <div class="importtexttwo">{{ value?.vessel }}</div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Consignee") }}
              </div>
              <div class="importtexttwo">{{ value?.importer_name }}</div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.MeansofTransport") }}
              </div>
              <div class="importtexttwo">{{ value?.trans_type }}</div>
            </div>
            <!-- <div class="importDetail-content-import">Exporter / Seller</div> -->
          </div>
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.CountryofOrigin") }}
              </div>
              <div class="importtexttwo">
                {{ getCountry(value?.origin_country) }}
              </div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Voyage") }}
              </div>
              <div class="importtexttwo">{{ value?.voyage }}</div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Notifier") }}
              </div>
              <div class="importtexttwo">{{ value?.notify_party_name }}</div>
            </div>
          </div>
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.CountryofDestnation") }}
              </div>
              <div class="importtexttwo">{{ value?.dest_country }}</div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.AddressofOrigin") }}
              </div>
              <div class="importtexttwo">{{ value?.poe }}</div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle"></div>
              <div class="importtexttwo"></div>
            </div>
            <!-- <div class="importDetail-content-import">Exporter / Seller</div> -->
          </div>
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.Shipper") }}
              </div>
              <div class="importtexttwo">{{ value?.supplier_name }}</div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.AddressofDestnation") }}
              </div>
              <div class="importtexttwo">{{ value?.poe }}</div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle"></div>
              <div class="importtexttwo"></div>
            </div>
            <!-- <div class="importDetail-content-import">Exporter / Seller</div> -->
          </div>
        </div>
      </div>
    </gui_card>
    <gui_card id="ge6845" class="uc1096" label="" :isShowLabel="false">
      <div>
        <h2 class="operations-head">
          {{ $t("ShippingOrderDetails.Container") }}
        </h2>
        <div class="importDetail-content">
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.ContainerID") }}
              </div>
              <div class="importtexttwo">{{ value?.container_id }}</div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.ContainerType") }}
              </div>
              <div class="importtexttwo">{{ value?.container_type }}</div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.ContainerDescDode") }}
              </div>
              <div class="importtexttwo">{{ value?.container_desc_code }}</div>
            </div>
            <!-- <div class="importDetail-content-import">Exporter / Seller</div> -->
          </div>
          <div class="flex_center_between_box importDetail-content-box">
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle">
                {{ $t("ShippingOrderDetails.ContainerSize") }}
              </div>
              <div class="importtexttwo">{{ value?.container_size }}</div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle"></div>
              <div class="importtexttwo"></div>
            </div>
            <div class="importDetail-content-second">
              <div class="importDetail-item-txt importtitle"></div>
              <div class="importtexttwo"></div>
            </div>
            <!-- <div class="importDetail-content-import">Exporter / Seller</div> -->
          </div>
        </div>
      </div>
    </gui_card>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
  <!--srcviewscompanydetailsBackgroundSnapshotvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart

import rectcard from "../../../../components/rectCard/index.vue";
import content_text from "../../../../components/text_content/index.vue";
import gui_card from "../../../../components/gui_card/gui_card.vue";
import ReLogin from "../../../../components/ReLogin.vue";
//importEnd
import { getbusinessActivitiesDetails } from "@/api/companyApi";
import { mixins1 } from "@/mixins/index";
export default {
  name: "",
  mixins: [mixins1],
  props: {
    // srcviewscompanydetailsBackgroundSnapshotvuePropsStart
    // srcviewscompanydetailsBackgroundSnapshotvuePropsEnd
  },
  mounted() {
    this.getbusinessActivitiesDetailsList();
    // defaultLoad
    // srcviewscompanydetailsBackgroundSnapshotvueMountedStart
    // srcviewscompanydetailsBackgroundSnapshotvueMountedEnd
  },

  components: {
    // gui_card start
    gui_card,
    // gui_card end

    rectcard,
    content_text,
    ReLogin,
  },
  computed: {
    limitedDescription() {
      const maxCharacters = 200;
      if (this.value && this.value?.commodity_description) {
        if (this.value.commodity_description.length > maxCharacters) {
          return (
            this.value?.commodity_description.substring(0, maxCharacters) +
            "..."
          );
        } else {
          return this.value?.commodity_description;
        }
      }
      return "";
    },

    rows() {
      const rows = [];
      let row = [];
      for (const item of this.content) {
        if (item.field) {
          row.push(item);
          if (row.length === 2) {
            rows.push(row);
            row = [];
          }
        } else {
          rows.push([item]);
        }
      }
      if (row.length > 0) {
        rows.push(row);
      }
      return rows;
    },
  },
  data() {
    return {
      reLoginVis: false,
      // insertData
      // srcviewscompanydetailsBackgroundSnapshotvueDataStart

      // LegalData
      LegalData: {
        color: "#009EA7",
        title: "Legal Status",

        data: [],
      },
      isExpanded: false,
      maxCharacters: 200,
      value: {},
      content: [],

      // FinancialData

      // srcviewscompanydetailsBackgroundSnapshotvueDataEnd
    };
  },

  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },
    getbusinessActivitiesDetailsList() {
      getbusinessActivitiesDetails({
        id: this.$route.query.DetailsiD,
      })
        .then((res) => {
          if (res.code == 200) {
            this.value = res.data;

            this.value.container_size =
              this.value?.container_size == undefined
                ? ""
                : this.value?.container_size.split(",")[0];
            this.value.container_type =
              this.value?.container_type == undefined
                ? ""
                : this.value?.container_type.split(",")[0];
            this.value.container_desc_code =
              this.value?.container_desc_code == undefined
                ? ""
                : this.value?.container_desc_code.split(",")[0];
            const container = this.$refs.scrollContainers; // 使用 ref 获取容器

            this.$parent.$parent.scrollToTop();
          } else {
            this.value = {};
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    // insertMethod
    // srcviewscompanydetailsBackgroundSnapshotvueMethodStart
    // default
    default() {},
    // srcviewscompanydetailsBackgroundSnapshotvueMethodEnd
  },
};
</script>
<style scoped>
.uPdtqFl {
  padding-right: 35px;
  padding-top: 26px;
  padding-left: 35px;
  padding-bottom: 26px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.importDetail-item-txt {
  margin-right: 10px;
  font-family: "Arial";
  font-size: 20px;
  color: #8497ab;
  line-height: 30px;
  text-align: left;
  font-style: normal;
}

.importDetail-item-conter {
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 20px;
  color: #1a2332;
  line-height: 30px;
  text-align: left;
  font-style: normal;
}

.importDetail-head {
  height: 60px;
  display: flex;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 18px 60px;
  margin-bottom: 20px;
}

.operations-head {
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 26px;
  color: #1a2332;
  line-height: 27px;
  text-align: left;
  font-style: normal;
}

.importDetail-content-head {
  width: 50%;
  margin-top: 30px;
  margin-bottom: 20px;
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 20px;
  color: #ff7600;
  line-height: 23px;
  text-align: left;
  font-style: normal;
}

.importtitle {
  margin-bottom: 14px;
}

.importtext {
  font-family: "Arial";
  font-size: 20px;
  color: #1290c9;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
}

.importDetail-content-import {
  width: 50%;
}

.importDetail-content-second {
  width: 30%;
}

.importDetail-content-box {
  padding-bottom: 30px;
}

.importDetail-content-box:last-child {
  padding-bottom: 0;
}

.importtexttwo {
  font-family: "Arial";
  font-size: 20px;
  color: #1a2332;
  line-height: 30px;
  text-align: left;
  font-style: normal;
}

.importDetail-content {
  margin-top: 30px;
}

.callBack {
  font-size: 18px;
  color: #1290c9;
  line-height: 20px;
  display: block;
  font-style: normal;
  text-decoration-line: underline;
  margin-bottom: 18px;
}

.uc1096 {
  margin-top: 10px;
  padding: 30px 40px;
}

.uc1096:first-child {
  margin-top: 0;
  padding: 24px 40px 40px;
}

.detail_con {
  padding-bottom: 20px;
}

.import_detail_root_back {
  width: 26px;
  height: 24px;
  margin-bottom: 20px;
}

@media screen and (max-width: 1920px) {
  .uPdtqFl {
    padding-right: 26px;
    padding-top: 20px;
    padding-left: 26px;
    padding-bottom: 20px;
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.12);
  }

  .importDetail-item-txt {
    margin-right: 7px;
    font-size: 16px;
    line-height: 22px;
  }

  .importDetail-item-conter {
    font-size: 16px;
    line-height: 22px;
  }

  .importDetail-head {
    height: 44px;
    padding: 14px 46px;
    margin-bottom: 15px;
  }

  .operations-head {
    font-size: 20px;
    line-height: 40px;
  }

  .importDetail-content-head {
    margin-top: 22px;
    margin-bottom: 15px;
    font-size: 16px;
    line-height: 18px;
  }

  .importtitle {
    margin-bottom: 10px;
  }

  .importtext {
    font-size: 16px;
    line-height: 22px;
  }

  .importDetail-content-box {
    padding-bottom: 22px;
  }

  .importtexttwo {
    font-size: 16px;
    line-height: 22px;
  }

  .importDetail-content {
    margin-top: 25px;
  }

  .callBack {
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 14px;
  }

  .uc1096 {
    margin-top: 7px;
    padding: 22px 30px;
  }

  .uc1096:first-child {
    padding: 18px 30px 30px;
  }

  .detail_con {
    padding-bottom: 15px;
  }

  .import_detail_root_back {
    width: 20px;
    height: 18px;
    margin-bottom: 15px;
  }
}

@media screen and (max-width: 1439px) {
  .uPdtqFl {
    padding-right: 24px;
    padding-top: 18px;
    padding-left: 24px;
    padding-bottom: 18px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.12);
  }

  .importDetail-item-txt {
    margin-right: 6px;
    font-size: 14px;
    line-height: 20px;
  }

  .importDetail-item-conter {
    font-size: 14px;
    line-height: 20px;
  }

  .importDetail-head {
    height: 40px;
    padding: 12px 40px;
    margin-bottom: 12px;
  }

  .operations-head {
    font-size: 18px;
    line-height: 20px;
  }

  .importDetail-content-head {
    margin-top: 20px;
    margin-bottom: 12px;
    font-size: 14px;
    line-height: 16px;
  }

  .importtitle {
    margin-bottom: 9px;
  }

  .importtext {
    font-size: 14px;
    line-height: 20px;
  }

  .importDetail-content-box {
    padding-bottom: 20px;
  }

  .importtexttwo {
    font-size: 14px;
    line-height: 20px;
  }

  .importDetail-content {
    margin-top: 20px;
  }

  .callBack {
    font-size: 14px;
    line-height: 12px;
    margin-bottom: 112x;
  }

  .uc1096 {
    margin-top: 6px;
    padding: 20px 26px;
  }

  .uc1096:first-child {
    padding: 16px 26px 26px;
  }

  .detail_con {
    padding-bottom: 12px;
  }

  .import_detail_root_back {
    width: 18px;
    height: 16px;
    margin-bottom: 12px;
  }
}
</style>
